/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Room Card
 */

import { Button, Col, Figure, Row } from 'react-bootstrap';
import { isMobile } from "react-device-detect";

// Icons
import { MdDoubleArrow } from 'react-icons/md';

// nodejs library that concatenates strings
import classnames from 'classnames';

// Hooks
import CheckScreen from './checkScreen';

// Components
import ImgNextGen from '../../../../components/ImgNextGen';

// Styles
import './style.scss'

const RoomCard = (props) => {
    const room = props.room;

    const mediaMobile = CheckScreen(767);
    const mobileScreen = isMobile & mediaMobile;

    // if width < 360 & desktop -> show detalhes button
    // if width < 768 (iPad) & mobile -> Só título e preço
    // if 360 < width < 768 (iPad) & desktop -> show detalhes

    return(
        <div data-aos="zoom-in">
            <Figure
                // className="room"
                className={classnames('room', mobileScreen ? 'mobile': null)}
                onClick={mobileScreen ? props.onClick : null}
            >
                <ImgNextGen
                    srcWebp={room.srcWebp}
                    fallback={room.src}
                    alt={room.title}
                />

                <Figure.Caption>
                    <h2>{room.title}</h2>
                    <div className="room-price"><span>Desde</span> {room.price.value}<sup>{room.price.sup}{room.price.per}</sup></div>
                    
                    <p>{room.text}</p>
                
                    <Row className="room-facilities">    
                        {room.mainFacilities.map((items, idx) => {
                            return(
                                <Col key={idx} xs>
                                    <ul>
                                        {items.map((facility, idx) => {
                                            return <li key={idx}>{facility.icon} {facility.text}</li>
                                        })}
                                    </ul>
                                </Col>
                            );
                        })}
                    </Row>

                    <Row className="absolute">
                        <Col xs={6}>
                            <Button className="btn-sm" onClick={props.onClick}>Ver Detalhes</Button>
                        </Col>
                        <Col xs={6}>
                            <a href="#contact">Reserve<i><MdDoubleArrow /></i></a>
                        </Col>
                    </Row>

                </Figure.Caption>
            </Figure>
        </div>
    );
}
export default RoomCard;